import { ButtonFillType } from '@/ui-kit/components/button/enums';
import { ListingNavigationCardVariant, ListingNavigationCardProperty } from '../enums';

const ListingNavigationCardProps = {
  props: {
    [ListingNavigationCardProperty.ImageSource]: {
      type: String,
      required: true,
    },
    [ListingNavigationCardProperty.Title]: {
      type: String,
      required: true,
    },
    [ListingNavigationCardProperty.Description]: {
      type: String,
      default: '',
    },
    [ListingNavigationCardProperty.ButtonLink]: {
      type: String,
      required: true,
    },
    [ListingNavigationCardProperty.ButtonFill]: {
      type: String,
      default: ButtonFillType.Outlined,
    },
    [ListingNavigationCardProperty.ButtonName]: {
      type: String,
      required: true,
    },
    [ListingNavigationCardProperty.Variant]: {
      type: String,
      default: ListingNavigationCardVariant.Vertical,
    },
    [ListingNavigationCardProperty.Origin]: {
      type: String,
      default: '',
    },
  },
};

export default ListingNavigationCardProps;
